export default __webpack_public_path__ + "images/OJ.04298fd.png";